import React, { useEffect } from 'react'

import { cn, useFilter } from '@rewardops/ui'

import { handleEnterKeyPress } from '~/utils/event-handler-utils'
import {
  ExtendSort,
  getLocalisedSortOptions,
  SortOptionsKeys,
} from '~/utils/filter-utils'
import { MapleSelect } from '~/components/maple/components/select'
import { useTranslation } from '~/app/i18n/client'

export const SortMenu = ({
  inputType = 'select',
  onSelectionSet,
}: {
  inputType?: 'select' | 'list'
  onSelectionSet?: Function
}) => {
  const { t } = useTranslation()
  const { sort, setSort } = useFilter()

  // Sets the default sort option to Newest arrivals
  useEffect(() => {
    if (!sort) {
      setSort(SortOptionsKeys.CreatedAt)
    }
  }, [])

  const defaultValue =
    getLocalisedSortOptions().find((o) => o.key === sort)?.key || undefined
  const options = getLocalisedSortOptions().map((option) => ({
    key: option.key,
    value: option.message,
  }))

  if (inputType === 'list') {
    return (
      <div className="flex flex-col gap-3 py-4">
        {getLocalisedSortOptions()?.map((option) => {
          const isSelected = option.key === sort
          return (
            <SortListItem
              onSelectionSet={onSelectionSet}
              setSort={setSort}
              selected={isSelected}
              option={option}
            />
          )
        })}
      </div>
    )
  }

  return (
    <MapleSelect
      key={sort}
      id="sort-select"
      className="w-[280px] justify-end"
      placeholder={t('filters.sortBy')}
      defaultValue={defaultValue}
      options={options}
      onValueChange={(s) => setSort(s)}
    />
  )
}

function SortListItem({
  onSelectionSet,
  selected,
  option,
  setSort,
}: {
  onSelectionSet?: Function
  selected: boolean
  option: ExtendSort
  setSort: any
}) {
  const handleKeyDown = () => {
    setSort(option.key)
    if (onSelectionSet) onSelectionSet()
  }

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    setSort(option.key)
    if (onSelectionSet) onSelectionSet()
  }

  return (
    <div
      id="sort-select"
      role="button"
      tabIndex={0}
      className={cn('cursor-pointer items-center hover:text-slate-400', {
        'font-semibold': selected,
      })}
      onKeyDown={(e) => handleEnterKeyPress(e, handleKeyDown)}
      onClick={handleClick}
    >
      {option.message}
    </div>
  )
}
